import { INFINITE_FAVORITES_USER } from "@/libs/apis/onboarding/reactQueryCacheKeys";
import { ERROR_CODES } from "@/libs/error/types";
import { CallbackWhenInView } from "@/src/components/CallbackWhenInView";
import { makeApiGetAllUserFavoriteTokensCall } from "@/src/services/api/favorites/getAllUserFavoriteTokens";
import { useInfiniteQuery } from "@tanstack/react-query";
import React from "react";
import LoadingSkeletonCards from "../../SkeletonCards";
import { PaginatedNFTS } from "./types";
import UserFavoriteProductCard from "./UserFavoriteProductCard";

type Props = { swooshHandle: string };

const UserFavorites: React.FC<Props> = ({ swooshHandle }) => {
  const { status, data, isFetchingNextPage, fetchNextPage, hasNextPage } =
    useInfiniteQuery<PaginatedNFTS, any, PaginatedNFTS>(
      [INFINITE_FAVORITES_USER, swooshHandle],
      ({ pageParam }) =>
        makeApiGetAllUserFavoriteTokensCall(swooshHandle, pageParam),
      {
        getNextPageParam: (lastPage, pages) => {
          return lastPage.nextPage;
        },
        useErrorBoundary: ({ response }) =>
          response !== undefined &&
          response?.status >= ERROR_CODES.INTERNAL_ERROR,
      },
    );
  const SkeletonCards = <LoadingSkeletonCards number={20} />;

  return (
    <div className="gap-sm items-start md:gap-base grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {status === "loading" ? (
        SkeletonCards
      ) : (
        <React.Fragment>
          {data?.pages?.map((page, index) => (
            <UserFavoriteProductCard
              nfts={page.items}
              swooshHandle={swooshHandle}
              key={`page-${index}`}
            />
          ))}
          {hasNextPage && isFetchingNextPage && SkeletonCards}
          <CallbackWhenInView
            disabled={!hasNextPage || isFetchingNextPage}
            callback={() => fetchNextPage()}
          />
        </React.Fragment>
      )}
    </div>
  );
};
export default UserFavorites;
